"use client";

import s from "./styles.module.css";

interface Props {
  src: string;
}

export default function Video({ src }: Props) {
  return (
    <video loop autoPlay playsInline controls={false} muted className={s.video}>
      <source src={src} type="video/mp4" />
    </video>
  );
}
